import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  pdf,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: { padding: 10 },
  header: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 10,
    textAlign: "center",
  },
  section: {
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    padding: 10,
    marginBottom: 10,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  text: { fontSize: 10, fontWeight: "bold", marginBottom: 5 },
  textValue: { fontWeight: "normal", fontSize: 10 },
  table: {
    display: "table",
    width: "100%",
    borderLeft: 1,
    borderColor: "#000",
    borderStyle: "solid",
    marginBottom: 10,
    borderTopWidth: 1,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#000",
  },
  tableCell: {
    padding: 5,
    fontSize: 10,
    textAlign: "center",
    flexGrow: 1,
    borderRightWidth: 1,
    borderColor: "#000",
    fontWeight: "bold",
  },
  subTableCell: {
    fontSize: 10,
    textAlign: "center",
    padding: 3,
    flexGrow: 1,
    borderRightWidth: 1,
    borderColor: "#000",
  },
  summary: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
  },
  summaryInner: {
    width: "30%",
    border: "1px solid #000",
    padding: 10,
  },
  summaryText: {
    fontWeight: "bold",
    fontSize: 10,
    marginBottom: 5,
  },
  summaryTextValue: {
    fontWeight: "normal",
    fontSize: 10,
    marginBottom: 5,
  },
  footer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    marginTop: 20,
    justifyContent: "space-between",
  },
});

const columns = [
  { name: "Particulars", key: "description", width: "20%" },
  { name: "Weight", key: "weight", width: "10%" },
  { name: "Quantity", key: "quantity", width: "10%" },
  { name: "Purity", key: "purity", width: "10%" },
  { name: "Rate", key: "rate", width: "10%" },
  { name: "Making", key: "making", width: "10%" },
  { name: "Wastage", key: "wastage", width: "10%" },
  { name: "Size/insil", key: "size", width: "10%" },
  { name: "Remarks", key: "remarks", width: "10%" }, 
  { name: "Sample Wt", key: "sampleWt", width: "10%" }, 
];

const itemColumns = [
  { name: "Item", key: "item", width: "50%" },
  { name: "Net Wt", key: "netWt", width: "25%" },
  { name: "Adv. Fine Wt", key: "advFineWt", width: "25%" },
];

export const InvoicePDF = ({ order }) => (
  <Document>
    <Page size={{ width: 842, height: 595 }} style={styles.page}>
      <Text style={styles.header}>Custom Order</Text>
      <View style={styles.section}>
        <View>
          <Text style={styles.text}>
            Customer Name:{" "}
            <Text style={styles.textValue}>{order.customerName || "N/A"}</Text>
          </Text>
          <Text style={styles.text}>
            Mobile:{" "}
            <Text style={styles.textValue}>{order.mobile || "N/A"}</Text>
          </Text>
          <Text style={styles.text}>
            Address:{" "}
            <Text style={styles.textValue}>{order.address || "N/A"}</Text>
          </Text>
        </View>
        <View>
          <Text style={styles.text}>
            Order No:{" "}
            <Text style={styles.textValue}>{order.orderNo || "N/A"}</Text>
          </Text>
          <Text style={styles.text}>
            Date:{" "}
            <Text style={styles.textValue}>{order.orderDate || "N/A"}</Text>
          </Text>
          <Text style={styles.text}>
            Delivery Date:{" "}
            <Text style={styles.textValue}>
              {order.deliveryDate || "N/A"}
            </Text>
          </Text>
        </View>
      </View>

      <View style={styles.table}>
        <View style={styles.tableRow}>
          {columns.map((col) => (
            <Text
              key={col.key}
              style={[styles.tableCell, { width: col.width }]}
            >
              {col.name}
            </Text>
          ))}
        </View>

        {order.items?.map((item, index) => (
          <View key={index} style={styles.tableRow}>
            {columns.map((col) => (
              <Text
                key={col.key}
                style={[styles.subTableCell, { width: col.width }]}
              >
                {item[col.key] || "-"}
              </Text>
            ))}
          </View>
        ))}
      </View>

      <View style={styles.summary}>
        <View style={styles.summaryInner}>
          <Text style={styles.summaryText}>Order Amount</Text>
          <Text style={styles.summaryText}>Total Amount</Text>
          <Text style={styles.summaryText}>Advance Paid</Text>
          <Text style={styles.summaryText}>Balance Amount</Text>
        </View>
        <View style={styles.summaryInner}>
          <Text style={styles.summaryTextValue}>
            {order.orderAmount || "N/A"}
          </Text>
          <Text style={styles.summaryTextValue}>
            {order.totalAmount || "N/A"}
          </Text>
          <Text style={styles.summaryTextValue}>
            {order.advancePaid || "N/A"}
          </Text>
          <Text style={styles.summaryTextValue}>
            {order.balanceAmount || "N/A"}
          </Text>
        </View>
      </View>

      <View style={styles.footer}>
        <Text style={{ fontSize: 10 }}>Customer Sign: </Text>
        <Text style={{ fontSize: 10 }}>For XYZ Jewellers</Text>
      </View>
    </Page>
  </Document>
);

export const CustomOrderPrint = () => {
  const order = {
    customerName: "John Doe",
    mobile: "1234567890",
    address: "123 Main St, City, Country",
    orderNo: "ORD12345",
    orderDate: "2025-03-01",
    deliveryDate: "2025-03-10",
    orderAmount: "550.000",
    advancePaid: "430.000",
    balanceAmount: "120.000",
    items: [
      {
        description: "Gold Purchase",
        weight: "10g",
        quantity: "1",
        purity: "24K",
        rate: "5000",
        amount: "5000",
        remarks: "N/A", 
        sampleWt: "N/A", 
      },
      {
        description: "Silver Exchange",
        weight: "20g",
        quantity: "2",
        purity: "22K",
        rate: "3000",
        amount: "6000",
        remarks: "N/A", 
        sampleWt: "N/A", 
      },
    ],
  };

  const handlePreview = async () => {
    const blob = await pdf(<InvoicePDF order={order} />).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  return (
    <div>
      <h2>Invoice Preview</h2>
      <button onClick={handlePreview}>Preview Order</button>
    </div>
  );
};

export const printOrder = async (order) => {
  console.log("Order Data Passed to printOrder:", order); // Debugging log to verify data
  const blob = await pdf(<InvoicePDF order={order} />).toBlob();
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank");
};

export default CustomOrderPrint;
